export interface AllocationDataType {
  allocationRecordId: string;
  city: string;
  principalOutstanding: string;
  validMobileNumber: string;
  fullName: string;
  emailId: string | null;
  accountNumber: string;
  collectableAmount: string;
  firstName: string;
  delinquency: string | null;
  state: string;
  region: string;
  isUnsubscribed: string;
}

export type ChannelName = 'Unallocated' | 'Digital' | 'Call' | 'Field';

export interface ChannelMetrics {
  sumWeightedAverage: string;
  avgOutstanding: string;
  sumOutstanding: string;
  numberOfRecords: string;
}

export type ChannelPlannerData = Record<ChannelName, ChannelMetrics>;

export enum PlannerTab {
  ALL_ACCOUNTS = 'all_accounts',
  UNSUBSCRIBED_ACCOUNTS = 'unsubscribed_accounts',
  ERRORS = 'errors',
}
export enum CallPlannerTab {
  BORROWER_GROUPS = 'borrower_groups',
  UNGROUPED_BORROWERS = 'ungrouped_borrowers',
}
export enum FieldPlannerTab {
  UNALLOCATED_ACCOUNTS = 'unallocated_accounts',
  ALLOCATED_ACCOUNTS = 'allocated_accounts',
}
